import script from "./ChangelogView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangelogView.vue?vue&type=script&setup=true&lang=js"

import "./ChangelogView.vue?vue&type=style&index=0&id=1d067fa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d067fa4"]])

export default __exports__